<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.vip_log") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.w-100
              .form-group.col-12.mb-1(v-if="!member_full_record")
                DateRangePicker(:value="dateRange" @update="getData")
              .form-group.col-md-3.col-2.mb-1(v-if="!isOperator")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-user-secret
                  DebounceInput(autofocus type="text" v-model="searchOperatorID" :placeholder="$t('ui.operator_id')" @enter="getLogList(true)" size="sm")
              .form-group.col-md-3.col-2.mb-1(v-if="searchOperatorID.length > 0")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-user
                  DebounceInput(autofocus type="text" v-model="searchMemberID" :placeholder="$t('ui.member_id')" @enter="getLogList(true)" size="sm")              
              .form-group.col-md-3.col-2.mb-1(v-if="!member_full_record")
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t('ui.status') }}
                  b-form-select(v-model="action_type" @change="getLogList(true)" size="sm")
                    option(value="") {{ $t('ui.all') }}
                    option(value="UP") {{ $t('ui.up') }}
                    option(value="UP_MAINTAIN") {{ $t("ui.up_maintain") }}
                    option(value="DOWN") {{ $t("ui.down") }}
                    option(value="DOWN_LOWEST") {{ $t("ui.down_lowest") }}
                    option(value="MAINTAIN") {{ $t("ui.maintain") }}
                    option(value="MANUAL") {{ $t("ui.manual") }}   
              .form-group.col-md-3.col-2
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend" :title="$t('ui.member_full_record')")
                    span {{ $t('ui.member_full_record') }}
                  b-input-group-text(slot="append")
                    label.custom-switch
                      input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="member_full_record")
                      span.custom-switch-indicator           
              .form-group.col-12.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getLogList(true)"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)")
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th.text-left(width="5%")
                          span(:title="$t('ui.id')") {{ $t('ui.id') }}
                        th.text-left(width="10%" @click="sortOrder('account_id')")
                          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                          .float-right
                            i(:class="changeSortKey('account_id')")
                        th.text-center(width="7%")
                          span(:title="$t('ui.cycle')") {{ $t('ui.cycle') }}
                        th(width="10%")
                          span(:title="$t('ui.before')") {{ $t('ui.before') }}
                        th(width="10%")
                          span(:title="$t('ui.after')") {{ $t('ui.after') }}
                        th(width="10%")
                          span(:title="$t('ui.total_deposit')") {{ $t('ui.deposit') }}
                        th(width="10%")
                          span(:title="$t('ui.total_turnover')") {{ $t('ui.turnover') }}
                        th(width="15%")
                          span(:title="$t('ui.reward_type')") {{ $t('ui.reward_type') }}
                        th.text-center(width="10%")
                          span(:title="$t('ui.action_status')") {{ $t('ui.action_status') }}
                        th.text-right(width="10%" @click="sortOrder('action_date')")
                          span(:title="$t('ui.action_date')") {{ $t('ui.action_date') }}
                          .float-right
                            i(:class="changeSortKey('action_date')")
                    tbody.clusterize-content
                      tr(v-if="logList.length == 0")
                        td(:colspan="12").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in logList")
                        td.text-center
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td.text-left
                          span(:title="item.id") {{ item.id }}
                        td.text-left
                          span(:title="item.account_id") {{ item.account_id }}
                        td.text-center
                          span {{ $moment(item.cycle_start).format('YYYY-MM-DD') }}
                          br
                          span {{ $moment(item.cycle_end).format('YYYY-MM-DD') }}
                        td
                          span
                            i.fas.fa-crown &nbsp;{{ item.before_vip_name }}
                          br
                          table.table.table-sm
                            tr
                              th.text-center {{ $t("ui.deposit") }}
                              th.text-center {{ $t("ui.turnover") }}
                            tr
                              td.text-center(:title='$t("ui.starting_deposit")') {{ $n(item.before_starting_deposit, 'currency') }}
                              td.text-center(:title='$t("ui.starting_turnover")') {{ $n(item.before_starting_turnover, 'currency') }}
                            tr
                              td.text-center(:title='$t("ui.cycle_deposit")') {{ $n(item.before_cycle_deposit, 'currency') }}
                              td.text-center(:title='$t("ui.cycle_turnover")') {{ $n(item.before_cycle_turnover, 'currency') }}
                        td
                          span
                            i.fas.fa-crown &nbsp;{{ item.after_vip_name }}
                          br
                          table.table.table-sm
                            tr
                              th.text-center {{ $t("ui.deposit") }}
                              th.text-center {{ $t("ui.turnover") }}
                            tr
                              td.text-center(:title='$t("ui.starting_deposit")') {{ $n(item.after_starting_deposit, 'currency') }}
                              td.text-center(:title='$t("ui.starting_turnover")') {{ $n(item.after_starting_turnover, 'currency') }}
                            tr
                              td.text-center(:title='$t("ui.cycle_deposit")') {{ $n(item.after_cycle_deposit, 'currency') }}
                              td.text-center(:title='$t("ui.cycle_turnover")') {{ $n(item.after_cycle_turnover, 'currency') }}
                        td
                          template(v-if="item.maintain_deposit != null")
                            span {{ $t("ui.maintain") + ": " + $n(item.maintain_deposit, 'currency') }}
                            br
                          template(v-if="item.target_deposit != null")
                            span {{ $n(item.before_cycle_deposit, 'currency') }} / {{ $n(item.target_deposit, 'currency') }}
                        td
                          template(v-if="item.maintain_turnover != null")
                            span {{ $t("ui.maintain") + ": " + $n(item.maintain_turnover, 'currency') }}
                            br
                          template(v-if="item.target_turnover != null")
                            span {{ $n(item.before_cycle_turnover, 'currency') }} / {{ $n(item.target_turnover, 'currency') }}
                        td
                          .row.pt-0
                            template(v-if="item.reward_type")
                              span {{ item.reward_type }}
                              template(v-if="item.reward_type == 'CASH'")
                                span {{ item.cash + " @ " + item.campaign_id }}
                              template(v-else)
                                span {{ item.cs + " @ " + item.social_platform }}
                            template(v-else)
                              span -
                        td.text-center
                          span {{ item.action_type }}
                            i.fa.fa-question-circle.ml-1#tooltip(v-if="item.action_type == 'UP_MAINTAIN'" data-bs-toggle="tooltip" data-bs-placement="bottom" :title="item.remark")
                          br
                          span {{ item.action_by }}
                        td.text-right
                          span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcel from "@/library/jsonToExcel.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel
  },
  data: () => ({
    loading: false,
    dateRange: {
      startDate: null,
      endDate: null,
    },
    account_id: "",
    searchOperatorID: "",
    searchMemberID: "",
    member_full_record: false,
    action_type: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    logList: [],
    currentPage: 1,
    totalRow: 0,
    sortKey: "account_id",
    sortType: "desc"
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    // operatorID() {
    //   return this.$store.getters.selectedOperatorID
    // },
    isEditAccess() {
      return this.$helpers.showActionButton("e_resultchangeslog");
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
    // this.getLogList(true);
    if(this.isOperator) {
      this.searchOperatorID = this.accountID
      this.getLogList(true);
    }
  },
  methods: {
    sortOrder(key, type) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getLogList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getLogList(true);
    },
    getLogList: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.memberVipLogUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          operator_id: this.searchOperatorID,
          member_full_record: this.member_full_record,
          action_type: this.action_type,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        if (this.searchMemberID.trim() != '')
          json.member_id = this.searchMemberID;

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.logList = response.data.dt;
                  this.totalRow = this.logList.length > 0 ? this.logList[0].totalrows : 0;
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.totalRow = 0;
        this.logList = [];
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getLogList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getLogList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
